import { isEmpty } from 'lodash';
import IOrder from '~/interfaces/IOrder';
import { PAYMENT_METHODS } from '~/utils/getEnums';
import getAddressFormatted from './getAddressFormatted';
import getCurrencyFormatted from './getCurrencyFormatted';

interface ISettingsCompany {
  print_description: string;
  waiter_name?: string;
  percentage_optional?: boolean;
  print_payment_value?: boolean;
  print_products?: boolean;
}

export default function getPrintHTML(
  data: IOrder,
  {
    print_description,
    waiter_name,
    percentage_optional,
    print_payment_value,
    print_products,
  }: ISettingsCompany,
) {
  console.log({
    data,
  });

  let products_txt = '';
  let address_txt = '';
  let payment = '';
  let header_txt = '';
  let waiter_txt = '';
  let percentage_txt = '';
  // data.total já inclui o couvert artístico
  // Calcular o subtotal (total - couvert artístico)
  let subtotalValue = parseFloat(`${data.total}`);
  if (data.artisticCouvertTotal) {
    subtotalValue -= data.artisticCouvertTotal;
  }
  if (data.shippingCost) {
    subtotalValue -= data.shippingCost;
  }

  const subtotalFormatted = getCurrencyFormatted(subtotalValue);

  // Calcular percentage_optional sobre o subtotal (se houver)
  let percentageValue = 0;
  if (percentage_optional) {
    percentageValue = (subtotalValue * 10) / 100;
    percentage_txt = `
    <tr class="ttu">
      <td colspan="2">OPCIONAL</td>
      <td align="right">${getCurrencyFormatted(percentageValue)}</td>
    </tr>
    `;
  }

  // Calcular o total final: subtotal + percentage_optional + couvert artístico
  const finalTotal =
    subtotalValue +
    percentageValue +
    (data.artisticCouvertTotal || 0) +
    (data.shippingCost || 0);

  if (waiter_name) {
    waiter_txt = `
    <tr class="sup ttu">
      <td colspan="2">
        <b>
        ATENDIDO POR
        </b>
      </td>
      <td align="right">${waiter_name}</td>
    </tr>
    `;
  }

  if (data.table?.uid) {
    header_txt = `
    <tr>
      <th colspan="3">
        <b>MESA ${data.table.name}</b>
      </th>
    </tr>
    `;
  } else {
    header_txt = `
    <tr>
          <th colspan="3">
            <b>${data.name}</b><br />
            ${data.whatsapp}
          </th>
        </tr>
    `;
  }

  if (data.chatbot) {
    let products = (data.products as any).replace('\n', '');
    products = products.replaceAll('\n', '<br/>');
    products_txt += `
    <tr>
      <td colspan="3">
        ${products}
      </td>
    </tr>
    `;
  }

  let orderType = 'DELIVERY';

  if (data.table?.uid) {
    orderType = `MESA ${data.table.name}`;
  } else if (isEmpty(data.address)) {
    orderType = `RETIRADA LOCAL`;
  }

  let footer_products = '';
  if (print_products) {
    footer_products = `
      <tr style="height: 65px" />
      <tr class="sup ttu">
        <td colspan="3">
          CÓDIGO DO PEDIDO: ${data.code}
        </td>
      </tr>
      <tr class="sup ttu">
        <td colspan="3">
          <b>
          CLIENTE: ${data.name}
          </b>
        </td>
      </tr>
      <tr class="sup ttu">
        <td colspan="3" style="font-size: 22px; font-weight: bold">
          ${orderType}
        </td>
      </tr>
      <tr class="sup ttu">
        <td colspan="3">
          ITENS DO PEDIDO
        </td>
      </tr>
      <tr class="sup ttu" />
    `;
  }

  if (!data.chatbot) {
    data.products.forEach(item => {
      const value = getCurrencyFormatted(parseFloat(item.value));
      const total = getCurrencyFormatted(
        parseFloat(item.value) * item.quantity,
      );
      let complements_txt = '';
      let complements2_txt = '';

      if (item.complements) {
        // console.log('item: ', item);

        if (item.pizza_type) {
          item.complements.forEach(complement => {
            const qtdComp = item.complements.filter(
              comp => comp.group === complement.group,
            ).length;

            complements_txt += `
            <tr>
              <td colspan="3">${complement.quantity}/${qtdComp} - ${complement.item.name}</td>
            </tr>`;
            complements2_txt += `
            <tr>
              <td colspan="3" style='font-size: 21px'>${complement.quantity}/${qtdComp} - ${complement.item.name}</td>
            </tr>`;
          });
        } else {
          item.complements.forEach(complement => {
            complements_txt += `
            <tr>
              <td colspan="3">${complement.quantity}x ${complement.item.name}</td>
            </tr>`;
            complements2_txt += `
            <tr>
              <td colspan="3" style='font-size: 21px'>- ${complement.item.name}</td>
            </tr>`;
          });
        }
      }

      products_txt += `
      <tr class="top">
        <td colspan="3"><b>${item.name}</b></td>
      </tr>`;

      if (print_products) {
        footer_products += `
          <tr>
            <td colspan="3"><b>${item.quantity} ${item.name}</b></td>
          </tr>
          ${
            item.observations
              ? `<tr>
            <td colspan="3">Obs: ${item.observations}</td>
            </tr>`
              : ''
          }
          ${complements2_txt}
        `;
      }

      if (print_description === '1') {
        products_txt += `
        <tr>
          <td colspan="3">${item.description || ''}</td>
        </tr>`;
      }

      if (item.observations) {
        products_txt += `
        <tr>
          <td colspan="3">Obs: ${item.observations}</td>
        </tr>`;
      }

      products_txt += complements_txt;
      products_txt += `
      <tr>
        <td>${value}</td>
        <td>${item.quantity}x</td>
        <td>${total}</td>
      </tr>`;
    });
  }

  let thing_txt = '';

  if (print_payment_value && data.thing) {
    const value = getCurrencyFormatted(parseFloat(data.thing));
    thing_txt += `
    <tr class="ttu">
      <td colspan="2">Receber</td>
      <td align="right">${value}</td>
    </tr>
    `;
  }

  if (data.thing) {
    const thing_value = getCurrencyFormatted(
      parseFloat(data.thing) - data.total,
    );
    thing_txt += `
    <tr class="ttu">
      <td colspan="2">Troco</td>
      <td align="right">${thing_value}</td>
    </tr>
    `;
  }

  let shipping_txt = '';
  if (data.shippingCost > 0) {
    shipping_txt = `
    <tr class="ttu">
      <td colspan="2">Entrega</td>
      <td align="right">${data.shippingCost_formatted}</td>
    </tr>
    `;
  }

  let addition_txt = '';
  if (data.additionValue && data.additionValue > 0) {
    addition_txt = `
    <tr class="ttu">
      <td colspan="2">Acréscimo</td>
      <td align="right">${data.additionValue_formatted}</td>
    </tr>
    `;
  }

  let artistic_couvert_txt = '';
  if (data.artisticCouvertTotal && data.artisticCouvertTotal > 0) {
    artistic_couvert_txt = `
    <tr class="ttu">
      <td colspan="2">Couvert Artístico</td>
      <td align="right">${getCurrencyFormatted(data.artisticCouvertTotal)}</td>
    </tr>
    `;
  }

  if (data.paymentMethod) {
    payment += `
    <tr class="ttu">
      <td colspan="2">Pagamento</td>
      <td align="right">${PAYMENT_METHODS[data.paymentMethod]}</td>
    </tr>`;
  }

  if (data.orderPayments && data.orderPayments.length > 0) {
    let tmp = '';
    data.orderPayments.forEach(item => {
      tmp += `<tr class="ttu">
      <td colspan="2" align="left">${
        PAYMENT_METHODS[item.payment_method_id] || 'NÃO DEFINIDO'
      }</td>
      <td align="right">${item.value_formatted}</td>
      </tr>`;
    });
    payment += `
    <tr class="sup ttu p--0">
      <td colspan="3">
        <b>Pagamento</b>
      </td>
    </tr>
    ${tmp}
    `;
  }

  if (!isEmpty(data.address) && data.address.road) {
    address_txt += `
      <tr class="sup ttu p--0">
        <td colspan="3">
          <b>Entrega</b>
        </td>
      </tr>
      <tr class="ttu">
        <td colspan="3" align="left">${getAddressFormatted(data.address)}</td>
      </tr>
    `;
  }

  if (!isEmpty(data.address) && !data.address.road) {
    address_txt += `
      <tr class="sup ttu p--0">
        <td colspan="3">
          <b>Entrega</b>
        </td>
      </tr>
      <tr class="ttu">
        <td colspan="3" align="left">${data.address}</td>
      </tr>
    `;
  }

  if (isEmpty(data.address)) {
    address_txt += `
      <tr class="sup ttu p--0">
        <td colspan="3">
          <b>Entrega</b>
        </td>
      </tr>
      <tr class="ttu">
        <td colspan="3" align="left">${
          data.table?.uid ? 'Consumo no local' : 'Retirada Local'
        }</td>
      </tr>
    `;
  }

  return `
  <!DOCTYPE html>
  <html lang="pt-BR">

  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Pedido</title>
    <style>
      body {
        display: flex;
        justify-content: center;
      }

      .text-center {
        text-align: center;
      }

      .ttu {
        text-transform: uppercase;
      }

      .printer-ticket {
        display: table !important;
        width: 100%;
        max-width: 300px;
        font-weight: light;
        line-height: 1.3em;
      }

      .printer-ticket,
      .printer-ticket * {
        font-family: Tahoma, Geneva, sans-serif;
        font-size: 16px;
      }

      .printer-ticket th:nth-child(2),
      .printer-ticket td:nth-child(2) {
        width: 50px;
      }

      .printer-ticket th:nth-child(3),
      .printer-ticket td:nth-child(3) {
        width: 90px;
        text-align: right;
      }

      .printer-ticket th {
        font-weight: inherit;
        padding: 10px 0;
        text-align: center;
        border-bottom: 1px dashed #bcbcbc;
      }

      .printer-ticket tbody tr:last-child td {
        padding-bottom: 10px;
      }

      .printer-ticket .sup td {
        padding: 10px 0;
        border-top: 1px dashed #bcbcbc;
      }

      .printer-ticket .sup.p--0 td {
        padding-bottom: 0;
      }

      .printer-ticket .title {
        font-size: 1.5em;
        padding: 15px 0;
      }

      .printer-ticket .top td {
        padding-top: 10px;
      }

      .printer-ticket .last td {
        padding-bottom: 10px;
      }
    </style>
  </head>

  <body>
    <table class="printer-ticket">
        <tr>
          <th class="title" colspan="3">
            <b>
              ${data.company_name.toUpperCase()}
            </b>
          </th>
        </tr>
        <tr>
          <th colspan="3">${data.created_at_formatted}</th>
        </tr>
        ${header_txt}
        <tr>
          <th class="ttu" colspan="3">
            <b>Cupom não fiscal</b>
          </th>
        </tr>
      <tbody>
        ${products_txt}
      </tbody>

        <tr class="sup ttu p--0">
          <td colspan="3">
            <b>Totais</b>
          </td>
        </tr>
        ${thing_txt}
        ${addition_txt}
        <tr class="ttu">
          <td colspan="2">Sub-total</td>
          <td align="right">${subtotalFormatted}</td>
        </tr>
        ${shipping_txt}
        ${artistic_couvert_txt}
        ${percentage_txt}
        <tr class="ttu">
          <td colspan="2">Total</td>
          <td align="right">${getCurrencyFormatted(finalTotal)}</td>
        </tr>
        ${payment}
        ${address_txt}
        ${waiter_txt}
        <tr class="sup ttu">
          <td colspan="3" align="center">
            <b>Código do Pedido: ${data.code}</b>
          </td>
        </tr>
        <tr class="sup p--0">
          <td colspan="3" align="center">
            Tecnologia
          </td>
        </tr>
        <tr>
          <td colspan="3" align="center">
            www.tem-pedido.web.app
          </td>
        </tr>
        ${footer_products}
        <tr style="height: 85px" />
        <tr>
          <td colspan="3" align="center">
            -
          </td>
        </tr>
    </table>
  </body>

  </html>

`;
}

// ${footer_products}
//
// <tr>
//   <td colspan="3" align="center">
//     -------------------------------------------------------------------
//   </td>
// </tr>
